import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
  name: 'navbar',
  initialState: {
    isNavBarOpen: true,
    isNavMenuOpen: false,
    focusSearch: false,
    isResourceFullscreenOpen: false,
    isDrawerOpen: false,
    isSpotlightOpen: false,
    isUserDropdownOpen: false,
    isFeedbackDrawerOpen: false,
    spotlights: [],
  },
  reducers: {
    setIsNavBarOpen: (state, action: { payload: boolean }) => ({
      ...state,
      isNavBarOpen: action.payload,
    }),
    setFocusSearch: (state, action: { payload: boolean }) => ({
      ...state,
      focusSearch: action.payload,
    }),
    setIsDrawerOpen: (state, action: { payload: boolean }) => ({
      ...state,
      isDrawerOpen: action.payload,
    }),
    setIsNavbarMenuOpen: (state, action: { payload: boolean }) => ({
      ...state,
      isNavMenuOpen: action.payload,
    }),
    setIsSpotlightOpen: (state, action: { payload: boolean }) => ({
      ...state,
      isSpotlightOpen: action.payload,
    }),
    setIsUserDropdownOpen: (state, action: { payload: boolean }) => ({
      ...state,
      isUserDropdownOpen: action.payload,
    }),
    setIsFeedbackDrawerOpen: (state, action: { payload: boolean }) => ({
      ...state,
      isFeedbackDrawerOpen: action.payload,
    }),
    setIsResourceFullscreenOpen: (state, action: { payload: boolean }) => ({
      ...state,
      isResourceFullscreenOpen: action.payload,
    }),
    setSpotlights: (state, action: { payload: any }) => ({
      ...state,
      spotlights: action.payload,
    }),
  },
});

export const {
  setIsNavBarOpen,
  setFocusSearch,
  setIsDrawerOpen,
  setIsNavbarMenuOpen,
  setIsSpotlightOpen,
  setIsUserDropdownOpen,
  setIsFeedbackDrawerOpen,
  setSpotlights,
  setIsResourceFullscreenOpen,
} = slice.actions;

export const isNavBarOpenSelector = (state) => state.navbar.isNavBarOpen;
export const focusSearchSelector = (state) => state.navbar.focusSearch;
export const isDrawerOpenSelector = (state) => state.navbar.isDrawerOpen;
export const isNavMenuOpenSelector = (state) => state.navbar.isNavMenuOpen;
export const isSpotlightOpenSelector = (state) => state.navbar.isSpotlightOpen;
export const isUserDropdownOpenSelector = (state) => state.navbar.isUserDropdownOpen;
export const isFeedbackDrawerOpenSelector = (state) => state.navbar.isFeedbackDrawerOpen;
export const isResourceFullscreenOpenSelector = (state) => state.navbar.isResourceFullscreenOpen;
export const spotlightsSelector = (state) => state.navbar.spotlights;

export default slice.reducer;
